/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'resources': {
    width: 18,
    height: 14.307,
    viewBox: '0 0 18 14.307',
    data: '<g data-name="Group 6645" transform="translate(0 -3.693)" _fill="none" _stroke="#262422" stroke-linecap="round" stroke-linejoin="round"><path pid="0" data-name="Line 160" d="M.5 11.5h17"/><rect pid="1" data-name="Rectangle 4326" width="17" height="10" rx="1" transform="translate(.5 7.5)"/><path pid="2" data-name="Path 3357" d="M5.901 7.074a2.881 2.881 0 115.761 0"/></g>'
  }
})
